import { Component, OnInit, Inject } from '@angular/core';
import { Paginacao } from '@app/models/util/paginacao';
import { MeAvisePesquisa } from '@app/models/me-avise-pesquisa';

import { CDSMask } from '@app/utils/cds-mask';
//import { CompleterItem } from 'ng2-completer';
import { IdDescricao } from '@app/models/util/id-descricao';

import { MeAviseService } from '@app/services/meavise.service';
import { ParticipanteService } from '@app/services/participante.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ConsultasService } from '@app/services/consultas.service';
import { UsuarioService } from '@app/services/usuario.service';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-meavise-lista',
  templateUrl: './me-avise-lista.component.html'
})
export class MeAviseListaComponent implements OnInit {

  lstMeAvisePesquisa: MeAvisePesquisa[] = [];
  paginacao: Paginacao = new Paginacao();
  somenteNaoRealizadas = true;
  todosFuturos = false;

  todosAtrasados = false;
  filtroDescricao = '';
  novaDataSelecionada: string | null = null;
  dataInicial = '';
  dataFinal = '';
  filtroUsuarioAtualId: number;
  cdsMask: CDSMask = new CDSMask();
  ConsultarOutrosUsuariosMeAvise = false;
  meAviseSelecionados: number[] = [];
  usuarioSelecionado: number = null;
  funcionarioSelecionado: number = null;
  lstFuncionarios: Array<IdDescricao>[] = [];
  lstUsuariosTransferencia: Array<IdDescricao>[] = [];
  checked: number = 0
  bsModalRef: BsModalRef;

  pesquisando: boolean = false;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private meAviseService: MeAviseService,
    private participanteService: ParticipanteService,
    private consultasService: ConsultasService,
    private modalService: BsModalService,
    private usuarioService: UsuarioService) { }

  ngOnInit() {
    this.obterPermissao();
    this.dataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.dataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);
    this.usuarioService.obterUsuarioLogado().toPromise().then(usuarioLogado => {
      this.funcionarioSelecionado = usuarioLogado;
      this.consultasService.consultar('USUARIO_APELIDO_E_NOMEFANTASIA').toPromise().then(data => {
        this.lstUsuariosTransferencia = data.filter((x: any) => x.Id !== usuarioLogado);
        this.lstFuncionarios = data;
      });
      this.obterTodos();
    });
  }

  pesquisar() {
    this.meAviseSelecionados = [];
    this.paginacao.itensPorPagina = 20;
    this.obterTodos();
    this.paginacao.paginaAtual = 1;
  }

  atualizaAtrasadosEFuturos(boxMudou: string){
    if(boxMudou === 'ATRASADOS'){
      if(this.todosAtrasados){
        this.todosFuturos = false;
      }
    }

    if(boxMudou === 'FUTUROS'){
      if(this.todosFuturos){
        this.todosAtrasados = false;
      }
    }

    this.obterTodos();
  }
  
  atualiza() {
    this.obterTodos();
  }

  public pageChanged(event: any): void {
    this.obterTodos(event.page);
  }

  obterTodos(pagina: number = 1) {
    this.pesquisando = true;

    this.meAviseService.obterPorUsuario(pagina, this.somenteNaoRealizadas, this.todosFuturos, this.todosAtrasados, this.dataInicial, this.dataFinal, this.funcionarioSelecionado).subscribe(
      data => {

        if (data?.length < 1 && this.todosFuturos != true) {
          this.toastr.warning(`Nenhum me avise foi encontrado entre ${this.dataInicial} e ${this.dataFinal}`);
          this.lstMeAvisePesquisa = [];
          return;
        }

        if (data?.length < 1 && this.todosAtrasados != true) {
          this.toastr.warning(`Nenhum me avise foi encontrado entre ${this.dataInicial} e ${this.dataFinal}`);
          this.lstMeAvisePesquisa = [];
          return;
        }

        this.lstMeAvisePesquisa = data.Dados;
        this.paginacao.totalDeItens = data.Total;
        this.pesquisando = false;
      },
      erro => {
        this.toastr.warning("Tente Novamente.");
        this.pesquisando = false;
      });
  }


 // todosFuturos(){
 //   this.meAviseService.obterPorUsuario(this.somenteNaoRealizadas, this.dataInicial, this.dataFinal, this.funcionarioSelecionado)
 // }
  // obterTodos(pagina: number) {
  //   this.meAviseService.obterPorUsuario(this.somenteNaoRealizadas, this.dataInicial, this.dataFinal, this.funcionarioSelecionado)
  //     .toPromise().then(data => {
  //       this.lstMeAvisePesquisa = data
  //     });
  // }

  // onItemSelect(selected: CompleterItem) {
  //   if (selected) {
  //     this.filtroUsuarioAtualId = selected.originalObject.Id;
  //   }
  // }

  obterPermissao() {
    this.participanteService.verificaPermissaoUsuario(0, 'ConsultarOutrosUsuariosMeAvise')
      .subscribe(data => {
        this.ConsultarOutrosUsuariosMeAvise = data;
      });
  }


  filtrarMeAvise() {
    this.meAviseSelecionados = [];
    for (let i = 0; i < this.lstMeAvisePesquisa.length; i++) {
      if (this.lstMeAvisePesquisa[i].checked) {
        this.meAviseSelecionados.push(this.lstMeAvisePesquisa[i].Id);
      }
    }
  }

  transferirMeAvise() {
    if (!this.usuarioSelecionado) {
      this.toastr.error('Selecione um funcionário para transferir.');
    } else {
      const obj = {
        usuarioId: this.usuarioSelecionado,
        meAvises: this.meAviseSelecionados,
      };
      this.meAviseService.transferirMeAvises(obj).toPromise().then(() => {
        this.obterTodos();
        this.toastr.success('Me avise transferido com sucesso');
      }).catch(() => {
        this.toastr.error('Ocorreu um erro, tente novamente');
      });
    }
  }

  transferirMultiplosMeAvise() {  
    if (!this.usuarioSelecionado && !this.novaDataSelecionada) {
      this.toastr.error('Selecione um funcionário ou uma nova data para continuar!');
      return;
    }
  
    if (this.novaDataSelecionada) {
      const dataAtualString = UtilitarioService.retornaDataAtualMaisDiasISO(0); //necessário para não haver diferença de UTC
      const dataAtual = new Date(dataAtualString);

      const novaData = new Date(this.novaDataSelecionada);

      if (novaData < dataAtual) {
        this.toastr.warning('A nova data não pode ser menor que a data de hoje!');
        return;
      }
    }
  
    const obj = {
      usuarioId: this.usuarioSelecionado,
      meAvises: this.meAviseSelecionados,
      novaDataMeAvise: this.novaDataSelecionada
    };
  
    this.meAviseService.transferirMultiplosMeAvises(obj).toPromise()
      .then(() => {
        this.obterTodos();
        this.novaDataSelecionada = null;
        this.toastr.success('Transferência realizada com sucesso!');
      })
      .catch(() => {
        this.toastr.error('Ocorreu um erro na transferência. Tente novamente!');
      });
  }

  selecionarTodos(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    if (checked) {
      this.lstMeAvisePesquisa.forEach((checked) => {
        checked.checked = true;
      });
    } else {
      this.lstMeAvisePesquisa.forEach((checked) => {
        checked.checked = false;
      });
    }
    this.filtrarMeAvise()
  }

  excluirMeAvise() {
    if (this.meAviseSelecionados.length > 8) {
      this.toastr.error(`Não é permitido apagar mais de 8 itens`, `Erro`);
      return;
    } else {
      const obj = {
        meAvises: this.meAviseSelecionados
      }
      this.toastr.info(`isso pode demorar até 10 segundos`, `Atenção`);
      this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
      this.bsModalRef.content.mensagem = 'Deseja realmente deletar este registro?';
      this.bsModalRef.content.confirmar = () => {
        document.getElementById('overlay').style.display = 'block';
        this.toastr.info(`isso pode demorar até 10 segundos`, `Atenção`);
        this.meAviseService.desativarMeAvises(obj).toPromise().then(() => {
          this.obterTodos();
          document.getElementById('overlay').style.display = 'none';
          this.toastr.success('Me avise excluido com sucesso!');
        }).catch(() => {
          document.getElementById('overlay').style.display = 'none';
          this.toastr.error(`Ocorreu um erro, tente novamente`);
        });
      };
    }
  }

}
